import store from "../../redux/store";
import Functions from "../Functions";
import { PermissionTypes } from "../Enums";

function GetAvdelningsHasSkapa() {
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return false;
  return state.user.user.avdelnings
    .filter((avd) => Functions.hasFlag(avd.permission, PermissionTypes.Skapa))
    .map((avdelning) => {
      return { id: avdelning.id, namn: avdelning.namn };
    });
}
store.subscribe(GetAvdelningsHasSkapa);

export default GetAvdelningsHasSkapa;
